import React, { useState } from 'react';

import SectionInfoHeader from '../../../../common/SectionInfoHeader';
import SvgIcon from '../../../../SvgIcon/SvgIcon';

import QuotationProductSearch from './search/QuotationProductSearch';
import QuotationProductCategories from './categories/QuotationProductCategories';
import QuotationProductFilters from './filters/QuotationProductFilters';
import QuotationProductViewToggle from './view/QuotationProductViewToggle';

import QuotationProductCardView from './card/QuotationProductCardView';
import QuotationProductListView from './list/QuotationProductListView';

import { ProductPanelItem } from '../../../../../types/productpanel/ProductPanelItem';

import { useQuotation } from '../../../../../hooks/sale/useQuotation';

import POSProductPlaceholder from '../../../pos/table/POSProductPlaceholder';

interface Props {
  onAddProductClick: (product: ProductPanelItem) => void;
}

const QuotationProductPanel: React.FC<Props> = ({ onAddProductClick }) => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================

  const { form } = useQuotation();

  // =====================================================
  // 🔹 State
  // =====================================================

  const [viewMode, setViewMode] = useState<'list' | 'cards'>('list');

  // =====================================================
  // 🔹 No Active Quotation
  // =====================================================

  if (!form?.id) {
    return (
      <POSProductPlaceholder mode={viewMode === 'list' ? 'list' : 'card'} />
    );
  }

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <div className="flex flex-col gap-5">
      {/* ===================================================== */}
      {/* 🔹 Header */}
      {/* ===================================================== */}

      <SectionInfoHeader
        icon={<SvgIcon name="box" />}
        title="Productos"
        description="Busca y agrega productos disponibles a la cotización."
      />

      {/* ===================================================== */}
      {/* 🔹 Search */}
      {/* ===================================================== */}

      <QuotationProductSearch />

      {/* ===================================================== */}
      {/* 🔹 Toolbar */}
      {/* ===================================================== */}

      <div
        className="
        flex
        flex-col
        gap-3

        xl:flex-row
        xl:items-center
        xl:justify-between
      "
      >
        {/* Categorías */}

        <div className="min-w-0 flex-1">
          <QuotationProductCategories />
        </div>

        {/* Acciones */}

        <div
          className="
          flex
          flex-wrap
          items-center
          justify-end
          gap-2
        "
        >
          <QuotationProductFilters />

          <QuotationProductViewToggle
            viewMode={viewMode}
            onChange={setViewMode}
          />
        </div>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Products */}
      {/* ===================================================== */}

      {viewMode === 'list' ? (
        <QuotationProductListView onAddProductClick={onAddProductClick} />
      ) : (
        <QuotationProductCardView onAddProductClick={onAddProductClick} />
      )}
    </div>
  );
};

export default QuotationProductPanel;
